export const IDOSaleContractAddress = "";
export const InfinityFactoryContractAddress =
  "0x160ef1aD92b0e2A7d452347Fb1c5f49f3069333d";
export const PayoutContractAddress =
  "0xEcCe33b2aB4730981EcB754951900528e5C597dF";

export const StackPayoutContractAddress =
  "0xa9453FE5B2137bE4A661A7c181D20642e2667B00";
// Stacking Contract Address
export const InfinityStackingAddress =
  "0xDCc5a556ea9708dC2FD32a6dD74DC22a0706C4Ec";

// export const InfinityStackingTokenAddress =
//   "0x0eF636889E043E120D025F128cA4D79Bf06C4688";
